import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, LucideIcon } from "lucide-react";

interface CardGridProps {
  children: ReactNode;
  cols?: 2 | 3 | 4;
}

interface CardProps {
  title: string;
  description: string;
  href: string;
  icon?: LucideIcon;
}

export function CardGrid({ children, cols = 3 }: CardGridProps) {
  const colClass = {
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
    4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
  }[cols];

  return <div className={`grid ${colClass} gap-3 my-6`}>{children}</div>;
}

export function Card({ title, description, href, icon: Icon }: CardProps) {
  return (
    <Link
      to={href}
      className="group flex flex-col gap-2 rounded-xl border border-border bg-bg-secondary p-4 hover:border-primary-border hover:bg-bg-elevated transition-colors"
    >
      {Icon && (
        <span className="w-8 h-8 rounded-lg bg-primary-dim border border-primary-border flex items-center justify-center text-primary-text">
          <Icon size={16} />
        </span>
      )}
      <div className="flex items-start justify-between gap-2">
        <h3 className="text-sm font-medium text-text group-hover:text-primary-text transition-colors">
          {title}
        </h3>
        <ArrowRight
          size={14}
          className="text-text-faint group-hover:text-primary mt-0.5 shrink-0 transition-colors"
        />
      </div>
      <p className="text-xs text-text-muted leading-relaxed">{description}</p>
    </Link>
  );
}
